/**
 * Platform detection from file-name signatures. Runs regardless of which tile
 * the user picked — a mismatch re-labels the parse instead of failing it.
 * Ordered: export-zip signatures first (strongest), folk-convention markdown
 * layouts last.
 */
import type { MemoryImportPlatform, NamedText } from './types.js';

export function detectPlatform(files: NamedText[]): MemoryImportPlatform | null {
  if (files.length === 0) return null;
  const paths = files.map((f) => f.name.toLowerCase());
  const bases = new Set(paths.map((p) => p.split('/').pop() ?? p));
  const anyPath = (re: RegExp) => paths.some((p) => re.test(p));

  // Export zips (strongest signals).
  if (bases.has('memories.json') && (bases.has('users.json') || bases.has('projects.json'))) return 'claude';
  if (bases.has('users.json') && bases.has('conversations.json')) return 'claude';
  if (bases.has('user.json') && bases.has('conversations.json')) return 'chatgpt';

  // Local agent layouts.
  if (anyPath(/(^|\/)\.codex\//) || bases.has('memory_summary.md') || bases.has('raw_memories.md') || anyPath(/(^|\/)rollout_summaries\//)) {
    return 'codex';
  }
  if (bases.has('soul.md') || bases.has('heartbeat.md') || (bases.has('user.md') && bases.has('memory.md'))) {
    return 'openclaw';
  }
  if (anyPath(/\.mdc$/) || bases.has('.cursorrules')) return 'cursor';
  if (bases.has('gemini.md')) return 'gemini';
  if (anyPath(/(^|\/)\.hermes\//)) return 'hermes';
  if (bases.has('claude.md') || anyPath(/(^|\/)projects\/[^/]+\/memory\//)) return 'claude';

  return null;
}
